import React, { Component } from 'react'
import { contactData } from '../Contacts/contact-data';

import './Choir.css';
import FullDirectory from '../Directory/FullDirectory/FullDirectory';
import ChoirMiddle from './ChoirMiddle';
import ChoirHigh from './ChoirHigh';

// files
import { FILE } from '../../utils/constants/pdf';

const linkStyle = {
  marginTop: '-20px',
  textDecoration: 'underline',
};

export default class Choir extends Component {
  state = {
    department: 'Choir',
    directors: [],
    high: false,
    middle: false,
    directory: false,
    files: {
      solo: [
        {
          title: 'Solo & Ensemble Entering Instructions',
          href: FILE.allSoloEntrance,
        },
      ],
      concert: [
        {
          title: 'Concert & SightReading Entering Instructions',
          href: FILE.allContestEntrance,
        },
        {
          title: 'Concert & SightReading SightReading Pilot',
          href: FILE.choirSightReadingPilot,
        },
        {
          title: 'Concert & SightReading Host Guidelines',
          href: FILE.choirConcertGuidelines,
        },
        {
          title: 'Concert & SightReading Schedule',
          href: FILE.choirVarsityCSR,
        },
        {
          title: 'Concert Evaluation Rubric',
          href: FILE.vocalConcertEval,
        },
        {
          title: 'Sight Reading Evaluation Rubric',
          href: FILE.vocalSightReading,
        },
        {
          title: 'Vocal Form 4',
          href: FILE.vocalForm4,
        },
        {
          title: 'Vocal Form 5',
          href: FILE.vocalForm5,
        },
      ],
      middleSolo: [
        {
          title: 'Solo & Ensemble Entering Instructions',
          href: FILE.allSoloEntrance,
        },
      ],
      middleConcert: [
        {
          title: 'Concert & SightReading Entering Instructions',
          href: FILE.allContestEntrance,
        },
        {
          title: 'Concert & SightReading SightReading Pilot',
          href: FILE.choirSightReadingPilot,
        },
        {
          title: 'Concert & SightReading Host Guidelines',
          href: FILE.choirConcertGuidelines,
        },
        {
          title: 'Concert Evaluation Rubric',
          href: FILE.vocalConcertEval,
        },
        {
          title: 'Sight Reading Evaluation Rubric',
          href: FILE.vocalSightReading,
        },
        {
          title: 'Vocal Form 4',
          href: FILE.vocalForm4,
        },
        {
          title: 'Vocal Form 5',
          href: FILE.vocalForm5,
        },
      ],
      schedules: [
        // {
        //   title: 'Region 20 Full Contest Schedule',
        //   href: FILE.contestSchedule2122,
        // },
      ],
    },
  };

  componentDidMount() {
    this.getContacts();
  }

  getContacts() {
    const choir = 'Choir';
    // axios.get(`/api/contacts?department=${choir}`).then((res) => {
    //   this.setState({ directors: res.data });
    // });
    const contactsFilter = contactData[0].filter(el => el.department === 'CHOIR')
    this.setState({ directors: contactsFilter });
  }

  toggleClick = (a, b, c) => {
    this.setState({
      high: a,
      middle: b,
      directory: c,
    });
  };

  render() {
    const { high, middle, directory, directors, files } = this.state;

    const map = directors.map((e) => {
      return (
        <div className="page_contacts" key={e.id}>
          <img
        src={e.img || 'https://res.cloudinary.com/dwvrok1le/image/upload/v1654014904/2207595.png'}

          alt="Director img" />
          <div>
            <h4>{e.name}</h4>
            <a href={'mailto:' + e.email}>
              <img
                className="email_icon"
                src="https://svgsilh.com/svg_v2/147563.svg"
                alt={e.email}
              />
            </a>
          </div>
          <p>{e.position}</p>
        </div>
      );
    });

    return (
      <div className="band_main">
        <div className="component_img" />
        <div className="band_content">
          <div className="band_header">
            <div className="band_header_container">
              <h1
                className="band_link a"
                onClick={() => this.toggleClick(false, false, false)}
              >
                Choir
              </h1>
              <div className="band_sub_nav">
                <h2
                  className="band_link a bl-1"
                  onClick={() => this.toggleClick(true, false, false)}
                >
                  High School
                </h2>
                <h2
                  className="band_link a bl-1"
                  onClick={() => this.toggleClick(false, true, false)}
                >
                  Middle School
                </h2>
                {/* <h2
                  className="band_link a bl-1"
                  onClick={() => this.toggleClick(false, false, true)}
                >
                  Directory
                </h2> */}
              </div>
            </div>
          </div>

          <div className="band_header_small">
            <div className="band_header_container">
              <h1
                className="band_link a big-link"
                onClick={() => this.toggleClick(false, false, false)}
              >
                Choir
              </h1>
              <div className="band_sub_nav">
                <h2
                  className="band_link a side-link"
                  onClick={() => this.toggleClick(true, false, false)}
                >
                  High School
                </h2>
                <h2
                  className="band_link a side-link"
                  onClick={() => this.toggleClick(false, true, false)}
                >
                  Middle School
                </h2>
                <h2
                  className="band_link a side-link"
                  onClick={() => this.toggleClick(false, false, true)}
                >
                  Directory
                </h2>
              </div>
            </div>
          </div>

          {!high && !middle && !directory && (
            <div className="band_home scroll">
              <div className="division-container">
                <h2>
                  All High School and Middle School events will be split up into
                  North/South zones.
                </h2>
                <h4>Check the following links to see the divisions.</h4>
                <ul className="band-division-links">
                  <li>
                    <a href={FILE.highSchoolDivisions} target="blank">
                      High School
                    </a>
                  </li>
                  <li>
                    <a href={FILE.middleSchoolDivisions} target="blank">
                      Middle School
                    </a>
                  </li>
                </ul>
              </div>
              <h2>Our Directors</h2>
              <div>
                <h4>Checkout the Region 20 choir website! </h4>
                <a
                  href="http://www.region20vocal.org/"
                  target="blank"
                  style={linkStyle}
                >
                  www.region20vocal.org
                </a>
              </div>
              <div className="map_holder">{map}</div>
            </div>
          )}

          {high && <ChoirHigh files={files} />}
          {middle && <ChoirMiddle files={files} />}
          {directory && (
            <div className="band_middle scroll">
              <h2 className="band_title">Directory</h2>
              <FullDirectory department={this.state.department} />
            </div>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Choir/Choir.js